import GetDate from "./getdate";

export default function GetTime(time) {
    var msDiff = new Date().getTime() - new Date(time).getTime();
    var min = Math.floor(msDiff / (1000 * 60));
    if (min < 1) {
        return 'now';
    } else {
        var hour = Math.floor(min / 60);
        if (hour < 1) {
            return min + "m";
        } else {
            var day = Math.floor(hour / 24);
            if (day < 1) {
                return hour + "h";
            } else if (day > 2) {
                var date = new Date(time);
                var dd = date.getDate();
                var mm = date.getMonth() + 1;
                if (dd < 10) {
                    dd = '0' + dd;
                }
                if (mm < 10) {
                    mm = '0' + mm;
                }
                var yy = date.getFullYear();

                var ddate = dd + "-" + mm + "-" + yy;
                return ddate.toString();
            } else {
                return day + "d";
            }
        }
    }
}